import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import React, { useState, useEffect } from 'react';
import { ToastContainer } from "react-toastify";
import { fetchUserDetails } from "../userThunk";
import 'react-toastify/dist/ReactToastify.css';
import { getUserPurchasesByEmail } from "../services/offreService";
import UserQuotaTab from "./MailClient/UserQuotaTab";
import MailTab from "./MailClient/MailTab";

function EnvoyerMailClient() {
  const authUser = useSelector((state: RootState) => state.user.user);
  const dispatch: AppDispatch = useDispatch();

  const [user, setUser] = useState<any>(null);
  const [activeTab, setActiveTab] = useState("mail");

  useEffect(() => {
    const fetchUserAndData = async () => {
      if (!authUser?.email) return;

      try {
        const res = await dispatch(fetchUserDetails((authUser as any).id) as any);
        let userData = res.payload;

        const purchasesData = await getUserPurchasesByEmail(authUser.email);
        userData = {
          ...userData,
          purchases: purchasesData.purchases || [],
          hasFreeOffer: purchasesData.purchases?.some((p: any) => p.offer?.is_free),
        };

        setUser(userData);
      } catch (error) {
        console.error("❌ Error fetching user details or purchases:", error);
      }
    };

    fetchUserAndData();
  }, [authUser?.id, authUser?.email, dispatch]);

  return (
    <>
      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "mail" ? "active" : ""}`}
            onClick={() => setActiveTab("mail")}
            role="button"
            aria-selected={activeTab === "mail"}
          >
            Envoyer un email
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "quota" ? "active" : ""}`}
            onClick={() => setActiveTab("quota")}
            role="button"
            aria-selected={activeTab === "quota"}
          >
            Mes offres & Quotas
          </a>
        </li>
      </ul>

      {activeTab === "mail" && <MailTab authUser={authUser} />}

      {activeTab === "quota" && (
        <UserQuotaTab user={user} authUserEmail={authUser?.email} />
      )}

      <ToastContainer />
    </>
  );
}

export default EnvoyerMailClient;